// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressInput_container__f7JiU","dropdown":"AddressInput_dropdown__FwIH2"};